// AUTO-GENERATED - Do not edit manually
// Generated by: bun run generate:icons

import fivegIcon from '@/assets/icons/5g.svg';
import arrowBottomBoldIcon from '@/assets/icons/arrow-bottom-bold.svg';
import arrowBottomIcon from '@/assets/icons/arrow-bottom.svg';
import arrowRightIcon from '@/assets/icons/arrow-right.svg';
import arrowUpIcon from '@/assets/icons/arrow-up.svg';
import bouyguesIcon from '@/assets/icons/bouygues.svg';
import bulletCheckIcon from '@/assets/icons/bullet-check.svg';
import chainsIcon from '@/assets/icons/chains.svg';
import checkIcon from '@/assets/icons/check.svg';
import crossIcon from '@/assets/icons/cross.svg';
import dataIcon from '@/assets/icons/data.svg';
import esimIcon from '@/assets/icons/esim.svg';
import filterIcon from '@/assets/icons/filter.svg';
import freeIcon from '@/assets/icons/free.svg';
import iconChevronDoubleLeftIcon from '@/assets/icons/icon-chevron-double-left.svg';
import iconChevronDoubleRightIcon from '@/assets/icons/icon-chevron-double-right.svg';
import iconChevronLeftIcon from '@/assets/icons/icon-chevron-left.svg';
import iconChevronRightIcon from '@/assets/icons/icon-chevron-right.svg';
import iconCrossIcon from '@/assets/icons/icon-cross.svg';
import iconGaugeSpeedIcon from '@/assets/icons/icon-gauge-speed.svg';
import iconInformationIcon from '@/assets/icons/icon-information.svg';
import iconMobileIcon from '@/assets/icons/icon-mobile.svg';
import iconShieldIcon from '@/assets/icons/icon-shield.svg';
import iconStarIcon from '@/assets/icons/icon-star.svg';
import iconTrophyIcon from '@/assets/icons/icon-trophy.svg';
import iconTvIcon from '@/assets/icons/icon-tv.svg';
import infiniIcon from '@/assets/icons/infini.svg';
import menuIcon from '@/assets/icons/menu.svg';
import networkIcon from '@/assets/icons/network.svg';
import orangeIcon from '@/assets/icons/orange.svg';
import padlockIcon from '@/assets/icons/padlock.svg';
import roundCircleArrowIcon from '@/assets/icons/round-circle-arrow.svg';
import sfrIcon from '@/assets/icons/sfr.svg';
import shieldIcon from '@/assets/icons/shield.svg';
import signalIcon from '@/assets/icons/signal.svg';
import simIcon from '@/assets/icons/sim.svg';
import starIcon from '@/assets/icons/star.svg';
import worldIcon from '@/assets/icons/world.svg';

const iconMap: Record<string, string> = {
  '5g': fivegIcon,
  'arrow-bottom-bold': arrowBottomBoldIcon,
  'arrow-bottom': arrowBottomIcon,
  'arrow-right': arrowRightIcon,
  'arrow-up': arrowUpIcon,
  'bouygues': bouyguesIcon,
  'bullet-check': bulletCheckIcon,
  'chains': chainsIcon,
  'check': checkIcon,
  'cross': crossIcon,
  'data': dataIcon,
  'esim': esimIcon,
  'filter': filterIcon,
  'free': freeIcon,
  'icon-chevron-double-left': iconChevronDoubleLeftIcon,
  'icon-chevron-double-right': iconChevronDoubleRightIcon,
  'icon-chevron-left': iconChevronLeftIcon,
  'icon-chevron-right': iconChevronRightIcon,
  'icon-cross': iconCrossIcon,
  'icon-gauge-speed': iconGaugeSpeedIcon,
  'icon-information': iconInformationIcon,
  'icon-mobile': iconMobileIcon,
  'icon-shield': iconShieldIcon,
  'icon-star': iconStarIcon,
  'icon-trophy': iconTrophyIcon,
  'icon-tv': iconTvIcon,
  'infini': infiniIcon,
  'menu': menuIcon,
  'network': networkIcon,
  'orange': orangeIcon,
  'padlock': padlockIcon,
  'round-circle-arrow': roundCircleArrowIcon,
  'sfr': sfrIcon,
  'shield': shieldIcon,
  'signal': signalIcon,
  'sim': simIcon,
  'star': starIcon,
  'world': worldIcon,
};

/**
 * Resolves an icon name to its URL.
 * If the input is already a full URL, returns it unchanged.
 * If it's an icon name, looks it up in the mapping.
 */
export function resolveIconUrl(icon: string | undefined): string | undefined {
  if (!icon) {
    return undefined;
  }

  if (icon.startsWith('http://') || icon.startsWith('https://') || icon.startsWith('/')) {
    return icon;
  }

  return iconMap[icon];
}
